/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * R3F's Canvas uses a custom React renderer that manages its own DOM nodes.
 * During HMR, React's reconciler can try to removeChild/insertBefore on nodes
 * that R3F already cleaned up, causing DOMException. TanStack Devtools can also
 * stamp data-tsd-source onto three.js hosts; R3F then throws on pierced props.
 * This boundary catches those errors and forces a clean remount via key rotation.
 */

import { Component, type ReactNode } from 'react';

export class CanvasErrorBoundary extends Component<
  { children: ReactNode },
  { remountKey: number }
> {
  state = { remountKey: 0 };

  static getDerivedStateFromError() {
    return {};
  }

  componentDidCatch(error: unknown) {
    const msg = error instanceof Error ? error.message : '';
    const isDomReconciliation =
      msg.includes('removeChild') ||
      msg.includes('insertBefore') ||
      msg.includes('appendChild');
    const isTsdSource =
      msg.includes('data-tsd-source') ||
      msg.includes('Ensure it is an object before setting');

    if (isDomReconciliation || isTsdSource) {
      this.setState((prev) => ({ remountKey: prev.remountKey + 1 }));
      return;
    }
    throw error;
  }

  render() {
    return (
      <div key={this.state.remountKey} style={{ width: '100%', height: '100%' }}>
        {this.props.children}
      </div>
    );
  }
}
